/* [Modified by Codex at 2026-09-08] 在不依赖内联脚本的情况下预览颜色变体图片，并兼容动态重新渲染的产品卡。 */
if (!customElements.get('product-card-swatches')) {
  class ProductCardSwatches extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.card = this.closest('.product-card-wrapper');
      this.primaryImage = this.card?.querySelector('.product-card__primary-image');
      this.swatches = Array.from(this.querySelectorAll('button[data-card-image-src]'));
      this.lockedSwatch = null;

      if (!this.card || !this.primaryImage || this.dataset.behavior !== 'image') return;

      this.originalImage = {
        src: this.primaryImage.getAttribute('src'),
        srcset: this.primaryImage.getAttribute('srcset'),
        alt: this.primaryImage.getAttribute('alt'),
      };

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('pointerenter', () => this.preview(swatch), {
          signal: this.abortController.signal,
        });
        swatch.addEventListener('focus', () => this.preview(swatch), {
          signal: this.abortController.signal,
        });
        swatch.addEventListener('click', (event) => this.select(event, swatch), {
          signal: this.abortController.signal,
        });
      });

      this.addEventListener('pointerleave', () => this.restore(), {
        signal: this.abortController.signal,
      });
      this.addEventListener(
        'focusout',
        (event) => {
          if (!this.contains(event.relatedTarget)) this.restore();
        },
        { signal: this.abortController.signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    preview(swatch) {
      if (!swatch.dataset.cardImageSrc) return;

      this.primaryImage.setAttribute('src', swatch.dataset.cardImageSrc);
      if (swatch.dataset.cardImageSrcset) {
        this.primaryImage.setAttribute('srcset', swatch.dataset.cardImageSrcset);
      }
      if (swatch.dataset.cardImageAlt) {
        this.primaryImage.setAttribute('alt', swatch.dataset.cardImageAlt);
      }
      this.card.classList.add('product-card-wrapper--swatch-active');
    }

    select(event, swatch) {
      event.preventDefault();
      event.stopPropagation();
      this.lockedSwatch = swatch;
      this.preview(swatch);

      this.swatches.forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (!swatch.dataset.productUrl) return;

      /* [Modified by Codex at 2026-10-14] 颜色切换保留系列导航路径而快速购买继续读取原产品地址 */
      const navigationUrl = swatch.dataset.navigationUrl || swatch.dataset.productUrl;
      this.card.querySelectorAll('.card__heading a[href]').forEach((link) => {
        link.href = navigationUrl;
      });
      /* [End] */
      this.card.querySelectorAll('.quick-add__submit[data-product-url]').forEach((button) => {
        button.dataset.productUrl = swatch.dataset.productUrl;
      });
    }

    restore() {
      if (this.lockedSwatch) {
        this.preview(this.lockedSwatch);
        return;
      }
      if (!this.originalImage) return;

      Object.entries(this.originalImage).forEach(([attribute, value]) => {
        if (value === null) {
          this.primaryImage.removeAttribute(attribute);
        } else {
          this.primaryImage.setAttribute(attribute, value);
        }
      });
      this.card.classList.remove('product-card-wrapper--swatch-active');
    }
  }

  customElements.define('product-card-swatches', ProductCardSwatches);
}
/* [End] */
